import { render, staticRenderFns } from "./default-rating.vue?vue&type=template&id=4373d6db&scoped=true&"
import script from "./default-rating.vue?vue&type=script&lang=ts&"
export * from "./default-rating.vue?vue&type=script&lang=ts&"
import style0 from "./default-rating.vue?vue&type=style&index=0&id=4373d6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4373d6db",
  null
  
)

export default component.exports